/**
 * FRONT-2594 — the stale-check decision before a Canvas document save.
 * `PUT /api/documents/:filename` is last-write-wins, so the editor fetches the
 * document fresh first and asks this function what to do.
 *
 * - `blocked-empty`: the draft is blank (checked first — nothing is saved
 *   either way, and the person's fix is to type something).
 * - `conflict`: the server's `updatedAt` is no longer the one the draft was
 *   started from (Eddy, or another tab, wrote in between).
 * - `save`: safe to write. A draft whose base is still `BASE_PENDING` has no
 *   timestamp to compare against, so only the blank check applies.
 */
/**
 * A draft's base while the row a save produced has not been read back yet (the
 * post-save re-read failed). It is not a real timestamp, so it can never equal
 * one: it means "take the base from the next row that arrives".
 */
export const BASE_PENDING = '__base-pending__';

export type SaveDecision = 'save' | 'conflict' | 'blocked-empty';

export function decideSave(input: {
  draft: string;
  baseUpdatedAt: string | null;
  serverUpdatedAt: string | null;
}): SaveDecision {
  if (input.draft.trim().length === 0) return 'blocked-empty';
  if (input.baseUpdatedAt === BASE_PENDING) return 'save';
  if (input.serverUpdatedAt !== input.baseUpdatedAt) return 'conflict';
  return 'save';
}

/** Same blank rule the editor uses to disable Save and show its reason. */
export function isBlankDraft(draft: string): boolean {
  return draft.trim().length === 0;
}
